var map = {
	"./goldcoin/airdrop-big.png": 19217,
	"./memetown/airdrop-big.png": 68300,
	"./reflection/airdrop-big.png": 68628,
	"./tapcoin/airdrop-big.png": 86780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9116;